webpackJsonp([73909688149182],{

/***/ 1376:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Cooking, Coding & Career Changes: A Chef’s Journey in Learning to Code","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/cooking-coding-and-career-changes-a-chefs-journey-in-learning-to-code","createdAt":"2017-10-20T19:38:34.457Z","blogAuthor":{"fields":{"name":"Kayla Asay","slug":"blog/author/kayla-asay"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5Lwiipwm3eKsuqUEIE4g4g/8fa7c7fd61c2bc1d89d3c642a1bd1d19/blog-post-blog-cooking-coding-and-career-changes-a-chefs-journey-in-learning-to-code.jpg"}}}}}]},"authorJson":{"name":"Kayla Asay","slug":"blog/author/kayla-asay","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/kayla-asay"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-kayla-asay-70bb8510f21df6be6c21.js